<template>
    <section id="bi" class="page-content">
        <main id="section-body">
            <div class="filters">
              <div class="filter">
                    <label>Metric Category</label>
                    <div class="control">
                        <div class="select">
                            <select placeholder="Select a category"
                            v-model="category" name="metric" id="metric" @change="filters.metric=undefined">
                            <option v-if="(user && user.is_superuser) || category.type=='client'" v-for="(category, key) in metrics" :key="key" :value="key">{{ key }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="filter" v-if="category">
                    <label>Metrics</label>
                    <div class="control">
                        <div class="select">
                            <select placeholder="Select the metric"
                            v-model="filters.metric" name="metric" id="metric" @change="data={}; cleanFilters()">
                            <option v-for="(metric, key) in metrics[category]" :key="metric.name" :value="key">{{ metric.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="filter">
                   <label>Carrier</label>
                    <div class="control">
                        <div class="select">
                        <select placeholder="Choose Carrier" name="carrier" id="carrier" v-model="filters.carrier">
                            <option :value="undefined"></option>
                            <option v-for="carrier in carriers" :key="carrier.id" :value="carrier.id">{{ carrier.official_name }}</option>
                        </select>
                        </div>
                    </div>
                </div>
                <div class="filter">
                    <label>POL</label>
                    <div class="control">
                        <search-combo url="ports" field="name" field2="locode" inputClass="input" searchField="search" @data="filters.pol=$event?$event.locode:undefined" :source="filters.pol"></search-combo>
                    </div>
                </div>
                <div class="filter">
                    <label>POD</label>
                      <div class="control">
                        <search-combo url="ports" field="name" field2="locode" inputClass="input" searchField="search" @data="filters.pod=$event?$event.locode:undefined" :source="filters.pod"></search-combo>
                      </div>
                </div>
                <div class="filter">
                    <label>Data Between</label>
                    <date-range-filter ref="dates" :dateMin.sync="filters.created_at_range_after" :dateMax.sync="filters.created_at_range_before"/>
                </div>
                <span v-if="category && filters.metric && metrics[category][filters.metric].numericFilters">
                    <div class="filter"
                    v-for="field in metrics[category][filters.metric].numericFilters" :key="field">
                        <label v-label>{{field}}</label>
                        <input class="input" type="number" v-model="filters[field]" min="1">
                    </div>
                </span>
                <a class="filter-reset button is-small is-primary" @click="generateChart(); pageNum=0">Update</a>
                <a class="filter-reset button is-small is-black" @click="exportChart(); pageNum=0">Export</a>
                <a class="filter-reset button is-small" @click="filters={}; data={}">Reset</a>
            </div>
            <spinner :notFullScreen="true" v-show="loadingTable"></spinner>
            <div class="chart-container" v-show="filters.metric && data.labels && data.labels.length > 0 && !loadingTable" v-if="category && filters.metric && !metrics[category][filters.metric].specialFormat && !metrics[category][filters.metric].specialType">
                <bar-char :data="data" :maxValue="maxValue" index="0" :hideTotal="metrics[category][filters.metric].hideTotal"
                :isNotStacked="metrics[category][filters.metric].isNotStacked" @click="chartClick($event)"></bar-char>
            </div>
            <div v-for="(year, key) in data" :key="key"
            v-show="filters.metric && !loadingTable" v-if="category && filters.metric && metrics[category][filters.metric].specialFormat && !metrics[category][filters.metric].specialType">
                <span class="title has-text-grey">{{key}}</span>
                <div v-for="(month, index) in year" :key="index">
                  <span style="font-size: 1.3em;margin-left:2em">{{index}}</span>
                    <div class="chart-container" style="margin-left:5em">
                        <bar-char :data="month" :maxValue="maxValue" :index="key+index" :hideTotal="metrics[category][filters.metric].hideTotal"
                        :isNotStacked="metrics[category][filters.metric].isNotStacked" @click="chartClick($event)"></bar-char>
                    </div>
                </div>
            </div>
            <div v-show="filters.metric && !loadingTable" v-if="category && filters.metric && metrics[category][filters.metric].specialType == 'table'">
              <bi-table :objects="dataArray" :title="metrics[category][filters.metric].entity" :url="metrics[category][filters.metric].url"
              :schema="metrics[category][filters.metric].schema" :columns="metrics[category][filters.metric].columns"
              @loadPage="generateChart($event)" :pageNum="pageNum" :userInfo="userInfo" :entity="metrics[category][filters.metric].entity"/>
            </div>
            <div v-if="data.labels && data.labels.length == 0 && !loadingTable">
              0 Results to show
            </div>
        </main>
    </section>
</template>

<script>
import SearchCombo from '@/components/SearchCombo'
import Spinner from '@/components/Spinner'
import BarChar from '@/components/BarChar'
import {mapActions, mapState} from 'vuex'
import DateRangeFilter from '@/components/DateRangeFilter'
import BiTable from '@/components/BiTable'
export default {
  name: 'bi',
  components: {DateRangeFilter, BarChar, Spinner, SearchCombo, BiTable},
  mounted () {
    this.$emit('loading')
    const promises = [
      this.getCarriers().then(response => { this.carriers = response })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
    this.$emit('loaded')
  },
  data () {
    return {
      category: '',
      carriers: [],
      filters: {},
      filterKeys: {'pol_loc__locode': 'pol', 'pod_loc__locode': 'pod'},
      data: {},
      dataArray: [],
      loadingTable: false,
      pageNum: 1
    }
  },
  props: ['userInfo'],
  methods: {
    ...mapActions({
      getCarriers: 'carrier/list',
      getChart: 'bi/get',
      export: 'bi/getExport'
    }),
    cleanFilters () {
      this.filters = {
        metric: this.filters.metric,
        carrier: this.filters.carrier,
        pol: this.filters.pol,
        pod: this.filters.pod,
        created_at_range_after: this.filters.created_at_range_after,
        created_at_range_before: this.filters.created_at_range_before
      }
    },
    generateChart (page) {
      this.loadingTable = true
      var filters = Object.assign({}, this.filters)
      if (page) {
        filters = Object.assign({page: page}, this.filters)
        this.pageNum = page
      }
      filters.metric = undefined
      this.getChart({url: this.filters.metric, category: this.category, filters: filters}).then(response => {
        this.loadingTable = false
        if (Array.isArray(response)) {
          this.dataArray = response
        } else {
          this.data = response
        }
      })
      .catch(() => {
        this.loadingTable = false
      })
    },
    exportChart () {
      this.loadingTable = true
      var selectedHeaders = this.metrics[this.category][this.filters.metric].columns
      if (this.userInfo && this.userInfo.userprofile && this.userInfo.userprofile[this.metrics[this.category][this.filters.metric].entity + '_fields']) {
        selectedHeaders = this.userInfo.userprofile[this.metrics[this.category][this.filters.metric].entity + '_fields']
      }
      var filters = Object.assign({column: selectedHeaders}, this.filters)
      filters.metric = undefined
      this.export({url: this.filters.metric, category: this.category, filters: filters}).then(response => {
        this.loadingTable = false
      })
      .catch(() => {
        this.loadingTable = false
      })
    },
    chartClick (element) {
      if (this.category && this.metrics[this.category][this.filters.metric].clickUrl) {
        this.filters.metric = this.metrics[this.category][this.filters.metric].clickUrl
        Object.keys(element).forEach(key => {
          if (this.filterKeys[key]) {
            this.filters[this.filterKeys[key]] = element[key]
          }
        })
        this.generateChart()
      }
    }
  },
  directives: {
    label: {
      bind (el) { el.textContent = el.textContent.replace(/_/g, ' ') }
    }
  },
  computed: {
    ...mapState({
      metrics: state => state.bi.metrics,
      maxValue: state => state.bi.maxValue,
      user: state => state.user.user
    })
  },
  watch: {
  }
}
</script>
<style lang="scss">
    .chart-container {
        border: 1px darkgray solid;
        background: white;
        border-radius: .5em;
        max-height:76vh;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/PageBi.vue